import { xyCoord } from 'helpers/positions';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useRef,
} from 'react';

type PanZoomContextValue = {
  canPan: boolean;
  hasPanned: boolean;
  setCanPan: (a: boolean) => void;
  scale: number;
  setScale: (s: number) => void;
  offset: { x: number; y: number };
  setOffset: (o: { x: number; y: number }) => void;
  pan: (o: { dx: number; dy: number }) => void;
  // version: number;
};

const PanZoomContext = createContext<PanZoomContextValue | null>(null);

export function usePanZoomContext() {
  const context = useContext(PanZoomContext);
  // invariant(context !== null); // don't do this, the context may be null!
  return context;
}

export const PanZoomContextProvider = (props: PropsWithChildren) => {
  const { children } = props;
  // // const version = useRef<number>(0);
  // const [version, setVersion] = useState<number>(0);
  const scale = useRef<number>(1);
  const offset = useRef<xyCoord>({ x: 0, y: 0 });
  const canPan = useRef<boolean>(false);
  const hasPanned = useRef<boolean>(false);

  const contextValue: PanZoomContextValue = useMemo(() => {
    return {
      get canPan() {
        return canPan.current;
      },
      get hasPanned() {
        return hasPanned.current;
      },
      setCanPan,
      get scale() {
        return scale.current;
      },
      setScale,
      get offset() {
        return offset.current;
      },
      setOffset,
      pan,
      // version,
      // get version() {
      //   return version.current;
      // },
    };
  }, []);

  // function update() {
  //   // version.current += 1;
  //   setVersion((prev) => prev + 1);
  //   // showDebugInfo({ v: version.current });
  //   // showDebugInfo({ pannable: canPan.current ? 'yes' : 'no' });
  // }
  function setCanPan(a: boolean) {
    canPan.current = a;
    // update();
  }
  function setScale(s: number) {
    scale.current = s;
    // update();
  }
  function setOffset(o: { x: number; y: number }) {
    offset.current = { x: o.x, y: o.y };
    hasPanned.current = true;
    // update();
  }
  function pan(o: { dx: number; dy: number }) {
    setOffset({
      x: (offset.current?.x ?? 0) + o.dx,
      y: (offset.current?.y ?? 0) + o.dy,
    });
  }

  return (
    <PanZoomContext.Provider value={contextValue}>
      {children}
    </PanZoomContext.Provider>
  );
};
